import { lazyOpenBizChatSidePaneFromDeeplink } from 'owa-bizchat-shared';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';

export interface mailCopilotRouteParameters {
    deeplink?: string;
}

export async function mailCopilotNavigationRouteHandler(
    params: mailCopilotRouteParameters
): Promise<void> {
    if (isGlobalFeatureEnabled('mon-copilot-bizchat')) {
        await lazyOpenBizChatSidePaneFromDeeplink.importAndExecute({
            source: 'MailRouteDeeplink',
            encodedDeepLink: params.deeplink,
        });
    }
}
